import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';


const BulkActions = ({ 
  selectedCandidates, 
  onClearSelection, 
  onBulkMove, 
  onBulkEmail, 
  onBulkReject,
  stages 
}) => {
  const [bulkAction, setBulkAction] = useState('');
  const [targetStage, setTargetStage] = useState('');

  const bulkActionOptions = [
    { value: '', label: 'Select Action' },
    { value: 'move', label: 'Move to Stage' },
    { value: 'email', label: 'Send Email' },
    { value: 'reject', label: 'Reject Candidates' },
    { value: 'schedule', label: 'Schedule Interviews' },
    { value: 'export', label: 'Export Data' }
  ];

  const stageOptions = stages?.map(stage => ({
    value: stage?.id,
    label: stage?.name
  }));

  const handleExecuteAction = () => {
    switch (bulkAction) {
      case 'move':
        if (targetStage) {
          onBulkMove(selectedCandidates, targetStage);
          setBulkAction('');
          setTargetStage('');
        }
        break;
      case 'email':
        onBulkEmail(selectedCandidates);
        setBulkAction('');
        break;
      case 'reject':
        onBulkReject(selectedCandidates);
        setBulkAction('');
        break;
      default:
        break;
    }
  };

  if (selectedCandidates?.length === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-card border border-border rounded-lg shadow-modal p-4 z-50">
      <div className="flex items-center space-x-4">
        {/* Selection Info */}
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-sm font-medium">
            {selectedCandidates?.length}
          </div>
          <span className="text-sm font-medium text-foreground">
            {selectedCandidates?.length} candidate{selectedCandidates?.length !== 1 ? 's' : ''} selected
          </span>
        </div>

        {/* Action Selection */}
        <Select
          options={bulkActionOptions}
          value={bulkAction}
          onChange={setBulkAction}
          placeholder="Choose action"
          className="w-40"
        />

        {/* Target Stage Selection (for move action) */}
        {bulkAction === 'move' && (
          <Select
            options={stageOptions}
            value={targetStage}
            onChange={setTargetStage}
            placeholder="Select stage"
            className="w-40"
          />
        )}

        {/* Action Buttons */}
        <div className="flex items-center space-x-2">
          <Button
            variant="default"
            size="sm"
            onClick={handleExecuteAction}
            disabled={!bulkAction || (bulkAction === 'move' && !targetStage)}
            iconName="Play"
            iconPosition="left"
          >
            Execute
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={onClearSelection}
            iconName="X"
            iconPosition="left"
          >
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;